import type { GuessRow } from "./keystate";



function rowToEmoji(marks: string, dark: boolean): string {
  return marks
    .split("")
    .map((m) => (m === "g" ? "🟩" : m === "y" ? "🟨" : dark ? "⬛" : "⬜"))
    .join("");
}

/** Classic share text: "Wordle 1,887 3/6" + grid. */
export function shareText(
  number: number,
  guesses: GuessRow[],
  won: boolean,
  dark = true,
  title = "Wordle",
): string {
  const n = number.toLocaleString("en-US");
  const head = `${title} ${n} ${won ? guesses.length : "X"}/6`;
  return [head, "", ...guesses.map((g) => rowToEmoji(g.marks, dark))].join("\n");
}
